'use strict';

/* global $ */

import { info } from '../utils/browser_info';

function ContactPageInit (options) {
    var opt = _.merge({ }, {
        itemSelector: '.js-contact-item',
        linkSelector: '.js-contact-link',
        mapSelector: '.js-contact-map',
        map: {
            zoom: 15,
            center: [55.210284, 61.440409],
            controls: ['default']
        },
        scrollOffset: 50
    }, options);

    class ContactPage {
        init(options) {
            let self = this;

            self.opt = _.extend({ }, options);

            self.$items = $(opt.itemSelector);
            self.$links = $(opt.linkSelector);
            self.$map = $(opt.mapSelector);
            self.$body = $(/webkit/.test(navigator.userAgent) ? document.body : document.documentElement);

            if (self.$items.length && self.$map.length) {
                ymaps.ready(function() {
                    self.start();
                });
            }
        }
        start() {
            let self = this;

            self.map = new ymaps.Map(self.$map.get(0), self.opt.map);

            for (let i = 0; i < self.$items.length; i ++) {
                let $item = self.$items.eq(i),
                    item = $item.data();

                item.coords = item.coords.split(/[^0-9.]+/);

                let placemark = new ymaps.Placemark(item.coords, {
                    balloonContentHeader: item.header,
                    balloonContentBody: item.content.replace(/\n/g, '<br />')
                }, {
                    preset: 'islands#brownIcon'
                });
                self.map.geoObjects.add(placemark);
            }

            self.$links.on('click', function(e) {
                e.preventDefault();
                self.showItem(self.$links.index(this));
            });

            self.showItem(0);
        }
        showItem(i) {
            let self = this;

            self.$items.removeClass('is-active').eq(i).addClass('is-active');
            self.map.setCenter(self.$items.eq(i).data('coords'), self.opt.map.zoom);

            if (info.mobile()) {
                self.$body.animate({ scrollTop: self.$map.offset().top - self.opt.scrollOffset });
            }
        }
    }

    let page = new ContactPage();
    page.init(opt);
}

export {
    ContactPageInit
};
